import React, { useEffect, useState } from 'react'
import Sheet from '@mui/joy/Sheet';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import TextField from '@mui/material/TextField';
import ToastMessage from '../../common/ToastMessage';
import HeaderMainPage from './Header/HeaderMainPage';
import LockResetRoundedIcon from '@mui/icons-material/LockResetRounded';
import { useNavigate } from 'react-router-dom';
import { EndPoints } from '../../utils/apiEndpoints';
import { StorageItems } from '../../utils/storageItems';
import { FieldErrors } from '../../domain/helpers/Errors';
import { darkModeBackgroud } from '../../utils/constants';
import { validateSchema } from '../../common/ValidateSchema';
import { forgetPassword } from '../../services/LoginService';
import { useLanguageStore } from '../../store/useLanguageStore';
import { useDarkModeStore } from '../../store/useDarkModeStore';
import { forgotPasswordSchema } from '../../domain/ValidationSchemas/ForgotPassword';

export const ForgotPassword = () => {
    const navigate = useNavigate();
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();
    const [email, setEmail] = useState<string>('');
    const [errors, setErrors] = useState<FieldErrors>({});

    useEffect(() => {
        const getEmail = localStorage.getItem(StorageItems.UPDATEEMAIL);
        if (getEmail) setEmail(getEmail);
    }, []);

    const sheetCss = {
        my: 30,
        py: 3,
        px: 2,
        gap: 0,
        width: 400,
        mx: 'auto',
        display: 'flex',
        borderRadius: 'md',
        flexDirection: 'column',
        boxShadow: '8px 8px 30px rgba(0, 0, 0, 0.2)',
        background: darkMode ? darkModeBackgroud : 'white'
    };

    const fieldTextCss = {
        color: darkMode ? 'white' : 'black',
        '& .MuiInputLabel-root': {
            color: darkMode ? 'white' : 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: darkMode ? 'white' : 'black',
            },
            '&:hover fieldset': {
                borderColor: darkMode ? '#90caf9' : '#1976d2',
            },
            '&.Mui-focused fieldset': {
                borderColor: darkMode ? '#90caf9' : '#1976d2',
            },
            '& input': {
                color: darkMode ? 'white' : 'black',
            },
        },
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const isValid = validateSchema(forgotPasswordSchema, { email });

        setErrors(isValid.errors);
        if (!isValid.result) return;

        try {
            await forgetPassword(email);
            ToastMessage.Success(language['ToastForgotPassword']);
            localStorage.removeItem(StorageItems.PASSWORD);
            navigate(EndPoints.LOGIN);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className='w-100 h-100'>
            <HeaderMainPage />
            <Sheet sx={sheetCss}>
                <div>
                    <Typography
                        component="div"
                        marginBottom="3"
                        className={`text-center fw-bold fs-2 mt-2 ${darkMode && 'text-white'}`}
                    >
                        <LockResetRoundedIcon
                            sx={{
                                width: 60,
                                height: 60,
                                padding: 2,
                                color: 'white',
                                marginBottom: 2,
                                borderRadius: '50%',
                                background: 'var(--btn-theme-background)',
                            }}
                        />
                    </Typography>
                    <form onSubmit={handleSubmit} className='d-flex flex-column'>
                        <TextField
                            id="Email"
                            label="Email"
                            variant="outlined"
                            className='mt-2 mb-2'
                            value={email}
                            sx={fieldTextCss}
                            helperText={errors?.email}
                            error={Boolean(errors?.email)}
                            onChange={(e) => setEmail(e.target.value)}
                            InputProps={{ style: { color: darkMode ? 'white' : 'inherit' } }}
                            InputLabelProps={{ style: { color: darkMode ? 'white' : 'inherit' } }}
                        />
                        <div className='d-flex align-items-center w-100 gap-2 mt-4 mb-2'>
                            <Button
                                className="w-50"
                                sx={{
                                    color: 'rgb(133, 146, 163)',
                                    fontSize: '16px', background: '#EBEDF0',
                                    '&:hover': { background: '#D1D5DB' }
                                }}
                                onClick={() => navigate(EndPoints.LOGIN)}
                            >
                                {language['Cancel']}
                            </Button>
                            <Button
                                type='submit'
                                className="w-50"
                                sx={{
                                    color: 'white',
                                    fontSize: '16px',
                                    background: 'var(--btn-theme-background)',
                                    '&:hover': { background: 'rgb(85, 88, 235)' }
                                }}
                            >
                                {language['Send']}
                            </Button>
                        </div>
                    </form>
                </div>
            </Sheet>
        </div>
    );
}
export default ForgotPassword